import { useUnifiedAuth } from "./auth/useUnifiedAuth";
import AppRoutes from "@/AppRoutes";
import { AppStateProvider } from "@/state/AppProvider";

export default function App() {
  const { isAuthenticated } = useUnifiedAuth();

  return (
    <AppStateProvider isAuthenticated={isAuthenticated}>
      <AppRoutes />
    </AppStateProvider>
  );
}
